import useFeatureFlag from "./use-feature-flag";
import { useIsHostedCluster } from "./use-is-hosted-cluster";

export const useIsConstrainedCluster = (): boolean => {
  const isHosted = useIsHostedCluster();
  const isUnconstrained = useFeatureFlag(
    "hosted-clusters-unconstrained",
    false,
  );

  return isHosted && !isUnconstrained;
};
